import React,{ useEffect} from "react";
import { BsHouseDoor } from "react-icons/bs";
import { AiOutlineSearch } from "react-icons/ai";
import { BsBoxSeam } from "react-icons/bs";
import { MdQrCodeScanner } from "react-icons/md";
import { MdGroups } from "react-icons/md";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BsGraphUp } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { AiOutlineHistory } from "react-icons/ai";
import { MdOutlineReportProblem } from "react-icons/md";
import TableDataQuickselect from "../management/Table/TableDataQuickselect";
import { useDispatch, useSelector } from "react-redux";
import { logInUser, setUserPermissions } from "../../redux/slices/user/userSlice";
import {getAuthorization} from "../../axios/AxiosAut";

function QuickSelect() {
  const modules = [
    {
      icon: <BsHouseDoor size={30} color="#1F78B4" />,
      title: "Warehouse",
      btn: [
        {
          logo: <AiOutlineSearch size={20} color="#1F78B4" />,
          text: "Find Item/product",
        },
        {
          logo: <BsBoxSeam size={20} color="#1F78B4" />,
          text: "Goods In/Out",
        },
        {
          logo: <MdQrCodeScanner size={20} color="#1F78B4" />,
          text: "Scan Barcode",
        },
      ],
    },
    {
      icon: <MdGroups size={30} color="#1F78B4" />,
      title: "Manage",
      btn: [
        {
          logo: <IoIosAddCircleOutline size={20} color="#1F78B4" />,
          text: "Add product",
        },
        {
          logo: <BsBoxSeam size={20} color="#1F78B4" />,
          text: "Schedule",
        },
        {
          logo: <BsGraphUp size={20} color="#1F78B4" />,
          text: "Statistics",
        },
      ],
    },
    {
      icon: <IoSettingsOutline size={30} color="#1F78B4" />,
      title: "Production",
      btn: [
        {
          logo: <AiOutlineSearch size={20} color="#1F78B4" />,
          text: "Search Item",
        },
        {
          logo: <IoSettingsOutline size={20} color="#1F78B4" />,
          text: "Start guide",
        },
        {
          logo: <MdOutlineReportProblem size={20} color="#1F78B4" />,
          text: "Report Issue",
        },
      ],
    },
  ];
  return (
    <>
      <div className="flex flex-col w-full ">
        <h2 className=" text-left font-Montserrat text-2xl font-bold text-black">
          Quick Select
        </h2>
        <div className="border-b-2 border-blue-200 w-20"></div>
      </div>
      <div className="flex mt-10 space-x-15 md:space-x-10 sm:space-x-5">
        {modules.map((item) => (
          <div className="bg-white shadow-lg border-cyan-100 border-1 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
            <div className="flex flex-col items-center py-4 font-Montserrat">
              {item.icon}
              <h2 className="mb-4">{item.title}</h2>
              {item.btn.map((btn) => (
                <div className="border-blue-200 border-2 py-2 px-2 flex rounded-sm my-2 w-4/5 justify-center items-center font-Montserrat">
                  {btn.logo}
                  <h2 className="px-2">{btn.text}</h2>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-row mt-8 mb-4 space-x-1">
        <svg
          className="mt-3"
          width="28"
          height="2"
          viewBox="0 0 32 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 1H31.5" stroke="#1F78B4" />
        </svg>

        <p className="font-Montserrat font-medium text-blue-100 text-base">
          Last view build
        </p>
      </div>
      <div className="flex mt-8">
        <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
          <div className="flex flex-col bg-white shadow-lg rounded-lg border-cyan-100 border-1 items-center  font-Montserrat">
            <div className="text-center ">
              <div className="text-center">
                <img
                  className="w-fit"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOiUgF3uHmcrMHRVkO4wFL1K38F_STyu3EmA&usqp=CAU"
                />
              </div>
            </div>
          </div>
          <div className="flex">
            <p className="mt-1 ml-1 font-medium">The build name</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mt-1.5 ml-auto"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
          </div>
          <p className="mt-1 ml-1 font-medium text-gray-50">
            {" "}
            step 3 out of 10
          </p>
        </div>

        <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
          <div className="flex flex-col bg-white shadow-lg rounded-lg border-cyan-100 border-1 items-center  font-Montserrat">
            <div className="text-center ">
              <div className="text-center">
                <img
                  className="w-fit"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOiUgF3uHmcrMHRVkO4wFL1K38F_STyu3EmA&usqp=CAU"
                />
              </div>
            </div>
          </div>
          <div className="flex">
            <p className="mt-1 ml-1 font-medium">The build name</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mt-1.5 ml-auto"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
          </div>
          <p className="mt-1 ml-1 font-medium text-gray-50">
            {" "}
            step 3 out of 10
          </p>{" "}
        </div>
        <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
          <div className="flex flex-col bg-white shadow-lg rounded-lg border-cyan-100 border-1 items-center  font-Montserrat">
            <div className="text-center ">
              <div className="text-center">
                <img
                  className="w-fit"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOiUgF3uHmcrMHRVkO4wFL1K38F_STyu3EmA&usqp=CAU"
                />
              </div>
            </div>
          </div>
          <div className="flex">
            <p className="mt-1 ml-1 font-medium">Project.pdf</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mt-1.5 ml-auto"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
          </div>
          <p className="mt-1 ml-1 font-medium text-gray-50">
            {" "}
            step 3 out of 10
          </p>{" "}
        </div>
        <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
          <div className="flex flex-col bg-white shadow-lg rounded-lg border-cyan-100 border-1 items-center  font-Montserrat">
            <div className="text-center ">
              <div className="text-center">
                <img
                  className="w-fit"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOiUgF3uHmcrMHRVkO4wFL1K38F_STyu3EmA&usqp=CAU"
                />
              </div>
            </div>
          </div>
          <div className="flex">
            <p className="mt-1 ml-1 font-medium">overview.pdf</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mt-1.5 ml-auto"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
          </div>
          <p className="mt-1 ml-1 font-medium text-gray-50">
            {" "}
            step 3 out of 10
          </p>{" "}
        </div>
        <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
          <div className="flex flex-col bg-white shadow-lg rounded-lg border-cyan-100 border-1 items-center  font-Montserrat">
            <div className="text-center ">
              <div className="text-center">
                <img
                  className="w-fit"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOiUgF3uHmcrMHRVkO4wFL1K38F_STyu3EmA&usqp=CAU"
                />
              </div>
            </div>
          </div>
          <div className="flex">
            <p className="mt-1 ml-1 font-medium">the build name</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mt-1.5 ml-auto"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
          </div>
          <p className="mt-1 ml-1 font-medium text-gray-50">
            {" "}
            step 3 out of 10
          </p>{" "}
        </div>
      </div>
      <div className="flex flex-row mt-8 mb-4 space-x-1">
        <svg
          className="mt-3"
          width="28"
          height="2"
          viewBox="0 0 32 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 1H31.5" stroke="#1F78B4" />
        </svg>

        <p className="font-Montserrat font-medium text-blue-100 text-base">
          Upcoming deadlines
        </p>
      </div>

      <div className="flex flex-wrap justify-center">
          <div
            className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
            // "w-[calc(100vw_-_12rem)]"
          >
            <TableDataQuickselect />
          </div>
      </div>

    </>
  );
}

export default QuickSelect;
